import { createSlice } from "@reduxjs/toolkit";
import deductCreditForStorage from "@custom/rtk-apis/paymentViaCredit/deductCreditforStorage";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const deductCreditForStorageSlice = createSlice({
  name: "deductCreditForStorageSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(deductCreditForStorage.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deductCreditForStorage.fulfilled, (state, { payload }) => {
        console.log("Fulfilled ",payload)
        state.loading = false;
        state.status = '201';
        state.result = payload;
        state.error=''
      })
      .addCase(deductCreditForStorage.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
        state.error = 'Something went wrong!'
      });
  },
});

export default deductCreditForStorageSlice.reducer;
